// extracted by mini-css-extract-plugin
module.exports = {"vanlife-J":"J_vanlife-J__SEML_"};